export default "<syr-header ></syr-header>\n<router-outlet></router-outlet>\n<!-- <syr-table [places]=\"places\"></syr-table> -->\n"